import { BaseModel } from "./BaseModel";

export interface UploadLog {
  timestamp: string;
  message: string;
}

/** One workflow record from `/workflows/status`, as shown in the audio workflows list. */
export interface AudioWorkflowRow {
  id: string;
  fileUrl: string;
  /** Raw pipeline steps map; overall status is derived in the view so list and popup agree. */
  steps: Record<string, any>;
  createdAt?: string;
  updatedAt?: string;
}

export interface AudioWorkflowsPagination {
  page: number;
  pageSize: number;
  totalCount: number;
  hasNext: boolean;
}

export interface PageUploadPDFModel extends BaseModel {
  selectedFile: File | null; // Keep for backward compatibility
  selectedFiles: File[]; // Multiple files support
  uploadLogs: UploadLog[] | null;
  simulationLogs: UploadLog[] | null;
  isUploading: boolean;
  fileUploadUUID: string;
  isProcessCompleted: boolean;
  simulation: boolean;
  completedPdfName: string; // Single PDF name (backward compatibility)
  completedPdfNames: string[]; // Multiple PDF names from completed job result
  processingLogs: Array<{ timestamp: string; message: string; level: string }>; // High-level processing logs
  audioWorkflows: AudioWorkflowRow[];
  audioWorkflowsLoading: boolean;
  audioWorkflowsError: string | null;
  audioWorkflowsPagination: AudioWorkflowsPagination;
  showUploadModal: boolean;
}

export const defaultPageUploadPDFModel = (): PageUploadPDFModel => {
  return {
    selectedFile: null,
    selectedFiles: [],
    uploadLogs: null,
    simulationLogs: null,
    isUploading: false,
    fileUploadUUID: "",
    isProcessCompleted: false,
    simulation: false,
    completedPdfName: "",
    completedPdfNames: [],
    processingLogs: [],
    audioWorkflows: [],
    audioWorkflowsLoading: false,
    audioWorkflowsError: null,
    audioWorkflowsPagination: { page: 1, pageSize: 10, totalCount: 0, hasNext: false },
    showUploadModal: false,
    id: 0,
    uid: "",
    requestId: "",
    createdAt: "",
    updatedAt: "",
    createdBy: 0,
    updatedBy: 0,
    isActive: true,
  };
};

